import { exchangeItemsConcept } from '@/returns/constants'

const getExchangedItem = lineItem => {
  if (lineItem.exchanged_for_item) return lineItem.exchanged_for_item
  if (lineItem.exchange_info) return lineItem

  return null
}

export const getLineItemsToShowByConcept = ({ conceptKey, lineItems, newItems }) => {
  if (conceptKey !== exchangeItemsConcept) return lineItems

  const exchangedItems = lineItems.map(getExchangedItem).filter(Boolean)

  if (!newItems?.length) return exchangedItems

  return [...exchangedItems, ...newItems]
}
